import * as jwt from './jwt'
import * as user from './user'
import * as tenant from './tenant'
import * as settings from './settings'
import * as patient from './patient'
import * as professional from './professional'

export default {
  ...jwt,
  ...user,
  ...tenant,
  ...settings,
  ...patient,
  ...professional
}



// WEBPACK FOOTER //
// ./src/store/getters/index.js